import { ClockIcon } from '~/components/icon/clock'
import { useCountdown } from '~/hooks/use-countdown'
import { m } from '~/paraglide/messages'
import { useTimestamp } from '~/resources/timestamp'

export function Countdown(props: { endDate: Date }) {
  const ts = useTimestamp()
  const countdown = useCountdown(() => ({
    now: ts(),
    endDate: props.endDate,
    includesDay: true,
  }))
  return (
    <div class="flex items-center space-x-[3px] text-sm text-white">
      <div class="size-5">
        <ClockIcon />
      </div>
      <p>
        {m.countdown_day({
          day: String(countdown().day),
        })}{' '}
        {m.countdown_hour({
          hour: String(countdown().hours),
        })}
      </p>
    </div>
  )
}
